import { render, staticRenderFns } from "./TranslationModelSelect.vue?vue&type=template&id=ff3468e6&"
import script from "./TranslationModelSelect.vue?vue&type=script&lang=js&"
export * from "./TranslationModelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports